module.exports = __webpack_public_path__ + "static/img/commodity_sing03.62ae269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/malls/commodity_sing03.png
// module id = CDPJ
// module chunks = 174